export const PENDENCIAS_TEXTS = {
  PAGE_TITLE: 'Ações necessárias para liberar novos pedidos',
  PAGE_SUBTITLE:
    'Regularize o(s) item(ns) abaixo o quanto antes para liberação do seu abastecimento.',
  OVERDUE_TITLE: 'Pagamentos pendentes',
  OVERDUE_DESCRIPTION:
    'Identificamos boleto(s) vencido(s). Para liberação do abastecimento realize o pagamento ou entre em contato com a central de atendimento. A compensação dependerá do tipo de pagamento. ',
  OVERDUE_LINK: 'Saiba mais',
  OVERDUE_ACTION_SLIPS: 'Ver boletos vencidos',

  PAYMENT_TERM_TITLE: 'Condição de pagamento',
  PAYMENT_TERM_DESCRIPTION:
    'Você não pode realizar o pedido de abastecimento pelo portal, para isso, entre em contato com a central de atendimento.',

  TAXPAYER_TITLE: 'Regularizar CNPJ',
  TAXPAYER_DESCRIPTION:
    'Identificamos que o CNPJ está irregular na Receita Federal ou com problemas de cadastro. Para liberação do abastecimento regularize a situação do CNPJ com o seu contador e entre em contato com o seu consultor comercial.',
  TAXPAYER_ACTION_CONSULTANT_DATA: 'Ver dados do consultor',
  TAXPAYER_ACTION_CONSULTANT_CHAT: 'Falar com o consultor',

  BASE_TITLE: 'Revisão da central de abastecimento',
  BASE_DESCRIPTION_PREFIX: 'Identificamos que uma ou mais bases estão ',
  BASE_DESCRIPTION_STRONG: 'irregulares.',
  BASE_DESCRIPTION_SUFFIX:
    ' Para liberação do abastecimento entre em contato com a central de atendimento e solicite a manutenção.',
  BASE_ACTION_LIST: 'Ver centrais irregulares',

  ACTION_CALL_CENTER: 'Falar com a central',

  MODAL_CALL_CENTER_TITLE: 'Falar com a central de atendimento',
  MODAL_CALL_CENTER_SUBTITLE: 'Fale conosco',

  MODAL_CONSULTANT_TITLE: 'Dados do consultor',

  MODAL_COMPENSATION_TITLE: 'Compensação por tipo de pagamento',
  MODAL_COMPENSATION_PIX_LABEL: 'QR code ou Pix: ',
  MODAL_COMPENSATION_PIX_VALUE: 'em até 15 min',
  MODAL_COMPENSATION_SLIP_LABEL: 'Código de Barras:',
  MODAL_COMPENSATION_SLIP_WEEKDAYS:
    'Seg a Sex (sempre no próximo dia útil após o pagamento)',
  MODAL_COMPENSATION_SLIP_WEEKEND:
    'Pagamentos aos finais de semana, a compensação ocorre às terças',

  MODAL_SLIPS_TITLE: 'Boletos vencidos',

  MODAL_BASES_TITLE: 'Centrais irregulares',
  MODAL_BASES_ALERT_PREFIX: 'Identificamos que uma ou mais bases estão ',
  MODAL_BASES_ALERT_STRONG: 'irregulares',
  MODAL_BASES_ALERT_SUFFIX:
    '. Para liberação do abastecimento solicite a manutenção.',
  BASE_IRREGULAR_BADGE: 'irregular',

  ACTION_TECHNICAL_ASSISTANCE: 'Solicitar assistência técnica',
};

export const PENDENCIAS_TAG_CATEGORY = 'pendencias';
